import React from "react";
import AfterLoginHeader from "../Layouts/AfterLoginHeader";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getCustomerProfileById } from "../../store/Slice/customerProfileSlice";
import {
  getCustomerUpdateProfile,
  ResetCustomerUpdateState,
} from "../../store/Slice/customerUpdateProfileSlice";
import { Toast } from "primereact/toast";
import { getContractorProfileById } from "../../store/Slice/contractorProfileSlice";
import {
  getContractorUpdateProfile,
  ResetContractorUpdateState,
} from "../../store/Slice/contractorProfileUpdateSlice";
import { getLabelDetailList } from "../../store/Slice/labelDetailSlice";

const UpdateProfile = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const toast = React.useRef(null);

  const customerUniqueCode = sessionStorage.getItem("Customer-vUniqueCode");
  const contractorUniqueCode = sessionStorage.getItem("Contractor-vUniqueCode");
  const noImage = "/assets/images/no-image.png";

  const [showNewPassword, setShowNewPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [firstName, setFirstName] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  const [address, setAddress] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [city, setCity] = React.useState("");
  const [zipCode, setZipCode] = React.useState("");
  const [state, setState] = React.useState("");
  const [country, setCountry] = React.useState("");
  const [newPassword, setNewPassword] = React.useState("");
  const [confirmPassword, setConfirmPassword] = React.useState("");
  const [firstNameError, setFirstNameError] = React.useState("");
  const [lastNameError, setLastNameError] = React.useState("");
  const [nameError, setNameError] = React.useState("");

  const [newPasswordError, setNewPasswordError] = React.useState("");
  const [confirmPasswordError, setConfirmPasswordError] = React.useState("");

  const [selectedImage, setSelectedImage] = React.useState(null);

  const [loading, setLoading] = React.useState("");

  const [phoneError, setPhoneError] = React.useState("");

  // const [errorMessage, setErrorMessage] = React.useState("");

  const { customerProfileDetailData } = useSelector(
    (state) => state.customerProfileDetail
  );

  const { contractorProfileDetailData } = useSelector(
    (state) => state.contractorProfileDetail
  );

  const { customerUpdateProfileData } = useSelector(
    (state) => state.customerUpdateProfile
  );

  const { contractorUpdateProfileData } = useSelector(
    (state) => state.contractorUpdateProfile
  );

  const { labelDetailData } = useSelector((state) => state.labelDetailList);

  const isCustomerLoggedIn =
    customerUniqueCode && customerUniqueCode !== "undefined";

  const isContractorLoggedIn =
    !isCustomerLoggedIn &&
    contractorUniqueCode &&
    contractorUniqueCode !== "undefined";

  let profileDataList = null;

  if (
    customerUniqueCode &&
    customerUniqueCode !== "undefined" &&
    customerUniqueCode.length > 0 &&
    customerProfileDetailData?.code === 200
  ) {
    profileDataList = customerProfileDetailData?.data;
  } else if (
    contractorUniqueCode &&
    contractorUniqueCode !== "undefined" &&
    contractorUniqueCode.length > 0 &&
    contractorProfileDetailData?.code === 200
  ) {
    profileDataList = contractorProfileDetailData?.data;
  }

  const [profilePictureUrl, setProfilePictureUrl] = React.useState(
    profileDataList?.vImage ? profileDataList?.vImage : noImage
  );

  const toggleNewPasswordVisibility = () => {
    setShowNewPassword((prev) => !prev);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword((prev) => !prev);
  };
  const handleCancelClick = () => {
    navigate("/profile");
  };

  React.useEffect(() => {
    if (isCustomerLoggedIn) {
      dispatch(
        getCustomerProfileById({
          vUniqueCode: customerUniqueCode,
        })
      );
    } else if (isContractorLoggedIn) {
      dispatch(
        getContractorProfileById({
          vUniqueCode: contractorUniqueCode,
        })
      );
    }
  }, [
    dispatch,
    customerUniqueCode,
    contractorUniqueCode,
    isCustomerLoggedIn,
    isContractorLoggedIn,
  ]);

  React.useEffect(() => {
    if (profileDataList) {
      setSelectedImage(profileDataList?.vImage || "");
      setProfilePictureUrl(profileDataList?.vImage || "");
      setName(profileDataList?.vFullName || "");
      setFirstName(profileDataList?.vFirstName || "");
      setLastName(profileDataList?.vLastName || "");
      setEmail(profileDataList?.vEmail || "");
      setPhone(profileDataList?.vMobile || "");
      setAddress(profileDataList?.tAddress || "");
      setCity(profileDataList?.vCity || "");
      setZipCode(profileDataList?.vZipCode || "");
      setState(profileDataList?.vRegion || "");
      setCountry(profileDataList?.vCountry || "");
    }
  }, [profileDataList]);

  // handle phone error
  const handlePhoneChange = (event) => {
    const phoneValue = event.target.value.trim();
    if (!/^\d*$/.test(phoneValue)) {
      return;
    }
    setPhone(phoneValue);
    event.target.value.trim() !== "" && setPhoneError("");

    if (phoneValue === "") {
      setPhoneError(" Phone Number is Required.");
    } else if (+phoneValue.length === 10) {
      setPhoneError("");
    } else {
      setPhoneError("Invalid Phone Number.");
    }
  };

  // handle image selection
  const allowedImageTypes = ["image/jpeg", "image/png", "image/jpg"];
  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      if (allowedImageTypes.includes(file.type)) {
        setSelectedImage(file);
        const reader = new FileReader();
        reader.onload = (e) => {
          // setImagePreview(e.target.result);
          setProfilePictureUrl(e.target.result); // Update the profile picture URL
          setSelectedImage(file); // Update selected image
        };
        reader.readAsDataURL(file);
      } else {
        alert(
          "Unsupported file type. Please select a .jpg, .jpeg, or .png file."
        );
        e.target.value = null;
      }
    }
  };

  const handleNewPasswordChange = (event) => {
    const newPasswordValue = event.target.value;
    event.target.value.trim() !== "" && setNewPasswordError("");
    setNewPassword(newPasswordValue);
    if (newPasswordValue.trim().length < 6) {
      setNewPasswordError("Enter min 6 characters.");
    } else if (
      confirmPassword.length > 0 &&
      newPasswordValue !== confirmPassword
    ) {
      setConfirmPasswordError("Passwords do not match.");
    } else {
      setNewPasswordError("");
      setConfirmPasswordError("");
    }
  };

  const handleConfirmPasswordChange = (event) => {
    const confirmPasswordValue = event.target.value;
    event.target.value.trim() !== "" && setConfirmPasswordError("");
    setConfirmPassword(confirmPasswordValue);
    if (!confirmPasswordValue || confirmPasswordValue === "") {
      setConfirmPasswordError("Please Enter Confirm Password.");
    }
    if (newPassword.length > 0 && confirmPasswordValue !== newPassword) {
      setConfirmPasswordError("Passwords do not match.");
    } else {
      setConfirmPasswordError("");
    }
  };

  const validateUpdateProfile = React.useCallback(() => {
    let isValid = true;

    setPhoneError("");
    setNewPasswordError("");
    setConfirmPasswordError("");
    setFirstNameError("");
    setLastNameError("");
    setNameError("");

    if (isCustomerLoggedIn) {
      if (firstName === "") {
        isValid = false;
        setFirstNameError("First Name is Required.");
      }

      if (lastName === "") {
        isValid = false;
        setLastNameError("Last Name is Required.");
      }
    }

    if (isContractorLoggedIn) {
      if (name === "") {
        isValid = false;
        setNameError("Name is Required.");
      }
    }
    if (phone === "") {
      isValid = false;
      setPhoneError(" Phone Number is Required.");
    } else if (+phone.length < 10) {
      isValid = false;
      setPhoneError("Invalid Phone Number.");
    }
    if (newPassword.length > 0) {
      if (confirmPassword.length === 0) {
        setConfirmPasswordError("Please Enter confirm password.");
        isValid = false;
      }
    }

    if (confirmPassword.length > 0 && newPassword !== confirmPassword) {
      setConfirmPasswordError("Passwords do not match.");
      isValid = false;
    }

    return isValid;
  }, [
    firstName,
    lastName,
    phone,
    name,
    newPassword,
    confirmPassword,
    isCustomerLoggedIn,
    isContractorLoggedIn,
  ]);

  const handleUpdateProfile = React.useCallback(
    async (e) => {
      e.preventDefault();
      const formData = new FormData();
      formData.append("vImage", selectedImage);
      if (customerUniqueCode) {
        formData.append("vUniqueCode", customerUniqueCode);
      }
      if (contractorUniqueCode) {
        formData.append("vUniqueCode", contractorUniqueCode);
        formData.append("vFullName", name);
      }

      if (customerUniqueCode) {
        formData.append("vFirstName", firstName);
        formData.append("vLastName", lastName);
      }

      formData.append("vEmail", email);
      formData.append("tAddress", address);
      formData.append("vMobile", phone);
      formData.append("vCity", city);
      formData.append("vRegion", state);
      if (customerUniqueCode) {
        formData.append("vCountry", country);
      }
      formData.append("vZipCode", zipCode);
      formData.append("vPassword", newPassword);

      const isValidData = validateUpdateProfile();
      if (isValidData) {
        if (isCustomerLoggedIn) {
          dispatch(getCustomerUpdateProfile(formData));
          setLoading(true);
        }
        if (isContractorLoggedIn) {
          dispatch(getContractorUpdateProfile(formData));
          setLoading(true);
        }
      }
    },
    [
      dispatch,
      validateUpdateProfile,
      isCustomerLoggedIn,
      isContractorLoggedIn,
      selectedImage,
      customerUniqueCode,
      contractorUniqueCode,
      name,
      firstName,
      lastName,
      email,
      address,
      phone,
      city,
      state,
      country,
      zipCode,
      newPassword,
    ]
  );

  React.useEffect(() => {
    const handleResponse = (responseData, resetAction) => {
      if (!responseData) return;

      const { code, message } = responseData;

      if (code === 200) {
        toast.current.show({
          severity: "success",
          summary: message,
          life: 2000,
          className: "custom-toast",
        });

        setTimeout(() => {
          dispatch(resetAction());
          setLoading(false);
          navigate("/profile");
        }, 2000);
      } else if (code === 400 || code === 404) {
        toast.current.show({
          severity: "error",
          summary: message,
          life: 2000,
          className: "custom-toast-error",
        });
        setLoading(false);
        dispatch(resetAction());
      }
    };

    handleResponse(customerUpdateProfileData, ResetCustomerUpdateState);
    handleResponse(contractorUpdateProfileData, ResetContractorUpdateState);
  }, [
    customerUpdateProfileData,
    contractorUpdateProfileData,
    dispatch,
    navigate,
  ]);

  const path = location.pathname.split("/")[1];

  React.useEffect(() => {
    dispatch(getLabelDetailList({ vSlug: path }));
  }, [dispatch, path]);

  const getLabels = React.useMemo(() => {
    if (labelDetailData?.code !== 200) return {};
    return labelDetailData.data.reduce((acc, item) => {
      acc[item.vLabel] = item.tText;
      return acc;
    }, {});
  }, [labelDetailData]);

  const editProfileHeading = getLabels["LBL_EDIT_PROFILE_MAIN_HEADING"];
  const informationHeading = getLabels["LBL_EDIT_PROFILE_INFORMATION_HEADING"];
  const firstNameLabel = getLabels["LBL_EDIT_PROFILE_FIRST_NAME_LABEL"];
  const lastNameLabel = getLabels["LBL_EDIT_PROFILE_LAST_NAME_LABEL"];
  const emailAddressLabel = getLabels["LBL_EDIT_PROFILE_EMAIL_ADDRESS_LABEL"];

  const phoneNumberLabel = getLabels["LBL_EDIT_PROFILE_PHONE_NUMBER_LABEL"];
  const privacyInformationHeading =
    getLabels["LBL_EDIT_PROFILE_PRIVACY_INFO_HEADING"];
  const newPasswordLabel = getLabels["LBL_EDIT_PROFILE_NEW_PASSWORD_LABEL"];
  const nameLabel = getLabels["LBL_EDIT_PROFILE_NAME_LABEL"];
  const confirmPassworLabel =
    getLabels["LBL_EDIT_PROFILE_CONFIRM_PASSWORD_LABEL"];

  const addressLabel = getLabels["LBL_EDIT_PROFILE_ADDRESS_LABEL"];
  const contactInfoHeading = getLabels["LBL_EDIT_PROFILE_CONTACT_INFO_HEADING"];
  const addressOneLabel = getLabels["LBL_EDIT_PROFILE_ADDRESS_ONE_HEADING"];
  const cityLabel = getLabels["LBL_EDIT_PROFILE_CITY_HEADING"];
  const zipCodeLabel = getLabels["LBL_EDIT_PROFILE_ZIP_CODE_HEADING"];
  const stateLabel = getLabels["LBL_EDIT_PROFILE_STATE_HEADING"];

  return (
    <div className="dashboard">
      <Toast ref={toast} />
      <div className="dashboard-app">
        <AfterLoginHeader />

        <div className="dashboard-content">
          <div className="session-big-section">
            <div className="row">
              <div className="col-lg-12">
                <h2 className="dash-maintitle">{editProfileHeading}</h2>

                <div className="main-card profile-maincard">
                  <div className="dashprofile-card">
                    <div className="dashprofile-imgDiv dashprofile-updateDiv">
                      <img
                        className="dashprofile-img"
                        src={profilePictureUrl ? profilePictureUrl : noImage}
                        alt={profileDataList?.vImageAlt}
                        onError={({ currentTarget }) => {
                          currentTarget.onerror = null;
                          currentTarget.src = noImage;
                        }}
                        width="120"
                        height="120"
                        loading="lazy"
                      ></img>
                      <div className="dashprofile-imgtitleDiv">
                        <div className="d-flex gap-lg-3 gap-2">
                          <div className="updateprofileDiv">
                            <label
                              htmlFor="input-file"
                              className="success-orangebtn"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="19"
                                viewBox="0 0 18 19"
                                fill="none"
                              >
                                <path
                                  d="M1 14V16C1 16.5304 1.21071 17.0391 1.58579 17.4142C1.96086 17.7893 2.46957 18 3 18H15C15.5304 18 16.0391 17.7893 16.4142 17.4142C16.7893 17.0391 17 16.5304 17 16V14M4 6L9 1M9 1L14 6M9 1V13"
                                  stroke="white"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>{" "}
                              Upload
                            </label>
                            <input
                              id="input-file"
                              type="file"
                              onChange={handleImageChange}
                            />
                          </div>
                          <button
                            className="success-orangebtn success-grayborderbtn"
                            onClick={handleCancelClick}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              height="20"
                              viewBox="0 0 18 20"
                              fill="none"
                            >
                              <path
                                d="M1 5H17M7 9V15M11 9V15M2 5L3 17C3 17.5304 3.21071 18.0391 3.58579 18.4142C3.96086 18.7893 4.46957 19 5 19H13C13.5304 19 14.0391 18.7893 14.4142 18.4142C14.7893 18.0391 15 17.5304 15 17L16 5M6 5V2C6 1.73478 6.10536 1.48043 6.29289 1.29289C6.48043 1.10536 6.73478 1 7 1H11C11.2652 1 11.5196 1.10536 11.7071 1.29289C11.8946 1.48043 12 1.73478 12 2V5"
                                stroke="#9E9E9E"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="dashprofile-card">
                    <div className="row">
                      <div className="col-xxl-10">
                        <div className="row justify-content-center">
                          <div className="col-xxl-10 col-xl-10">
                            <h3 className="dashsmall-bluetitle">
                              {informationHeading}
                            </h3>
                            <div className="login-form pt-0 pb-0">
                              <div className="row g-4">
                                {customerUniqueCode &&
                                customerUniqueCode.length > 0 &&
                                customerUniqueCode !== "undefined" ? (
                                  <>
                                    <div className="col-lg-6 col-md-6">
                                      <div className="login-inputDiv mb-0">
                                        <label
                                          htmlFor="exampleInputname"
                                          className="form-label"
                                        >
                                          {firstNameLabel}
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          id="exampleInputname"
                                          placeholder={`Enter Your ${
                                            firstNameLabel || ""
                                          }`}
                                          value={firstName}
                                          onChange={(e) => {
                                            setFirstName(e.target.value);
                                            setFirstNameError("");
                                          }}
                                        />
                                        {firstNameError && (
                                          <div className="validation-error">
                                            {firstNameError}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6">
                                      <div className="login-inputDiv mb-0">
                                        <label
                                          htmlFor="exampleInputname"
                                          className="form-label"
                                        >
                                          {lastNameLabel}
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          id="exampleInputname"
                                          placeholder={`Enter Your ${
                                            lastNameLabel || ""
                                          }`}
                                          value={lastName}
                                          onChange={(e) => {
                                            setLastName(e.target.value);
                                            setLastNameError("");
                                          }}
                                        />
                                        {lastNameError && (
                                          <div className="validation-error">
                                            {lastNameError}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <div className="col-lg-6 col-md-6">
                                    <div className="login-inputDiv mb-0">
                                      <label
                                        htmlFor="exampleInputname"
                                        className="form-label"
                                      >
                                        {nameLabel}
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="exampleInputname"
                                        placeholder={`Enter Your ${
                                          nameLabel || ""
                                        }`}
                                        value={name}
                                        onChange={(e) => {
                                          setName(e.target.value);
                                          setNameError("");
                                        }}
                                      />
                                      {nameError && (
                                        <div className="validation-error">
                                          {nameError}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                )}
                                <div className="col-lg-6 col-md-6">
                                  <div className="login-inputDiv mb-0">
                                    <label
                                      htmlFor="exampleInputname"
                                      className="form-label"
                                    >
                                      {emailAddressLabel}
                                    </label>
                                    <input
                                      type="email"
                                      className="form-control"
                                      id="exampleInputemail"
                                      placeholder={`Enter Your ${
                                        emailAddressLabel || ""
                                      }`}
                                      value={email}
                                      readOnly
                                    />
                                  </div>
                                </div>
                                {customerUniqueCode &&
                                customerUniqueCode.length > 0 &&
                                customerUniqueCode !== "undefined" ? null : (
                                  <div className="col-lg-6 col-md-6">
                                    <div className="login-inputDiv mb-0">
                                      <label
                                        htmlFor="exampleInputname"
                                        className="form-label"
                                      >
                                        {addressLabel}
                                      </label>
                                      <input
                                        type="address"
                                        className="form-control"
                                        id="exampleInputaddress"
                                        placeholder={`Enter Your ${
                                          addressLabel || ""
                                        }`}
                                        value={address}
                                        onChange={(e) =>
                                          setAddress(e.target.value)
                                        }
                                      />
                                    </div>
                                  </div>
                                )}
                                <div className="col-lg-6 col-md-6">
                                  <div className="login-inputDiv mb-0">
                                    <label
                                      htmlFor="exampleInputname"
                                      className="form-label"
                                    >
                                      {phoneNumberLabel}
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      id="exampleInputphone"
                                      placeholder={`Enter Your ${
                                        phoneNumberLabel || ""
                                      }`}
                                      value={phone}
                                      onChange={handlePhoneChange}
                                      maxLength={10}
                                    />
                                  </div>
                                  {phoneError && (
                                    <div className="validation-error">
                                      {phoneError}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {customerUniqueCode ? null : (
                    <div className="dashprofile-card">
                      <div className="row">
                        <div className="col-xxl-10">
                          <div className="row justify-content-center">
                            <div className="col-xxl-10 col-xl-10">
                              <h3 className="dashsmall-bluetitle">
                                {contactInfoHeading}
                              </h3>
                              <div className="login-form pt-0 pb-0">
                                <div className="row">
                                  <div className="col-lg-6 col-md-6">
                                    <div className="login-inputDiv">
                                      <label
                                        htmlFor="exampleInputaddress"
                                        className="form-label"
                                      >
                                        {addressLabel}
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="exampleInputaddress"
                                        placeholder={`Enter Your ${
                                          addressLabel || ""
                                        }`}
                                        value={address}
                                        onChange={(e) =>
                                          setAddress(e.target.value)
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div className="col-lg-6 col-md-6">
                                    <div className="login-inputDiv">
                                      <label
                                        htmlFor="exampleInputaddress"
                                        className="form-label"
                                      >
                                        {addressOneLabel}
                                      </label>
                                      <input
                                        type="email"
                                        className="form-control"
                                        id="exampleInputemail"
                                        placeholder={`Enter Your ${
                                          addressOneLabel || ""
                                        }`}
                                        value={address}
                                        onChange={(e) =>
                                          setAddress(e.target.value)
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div className="col-lg-6 col-md-6">
                                    <div className="login-inputDiv">
                                      <label
                                        htmlFor="exampleInputcity"
                                        className="form-label"
                                      >
                                        {cityLabel}
                                      </label>
                                      <input
                                        type="city"
                                        className="form-control"
                                        id="exampleInputcity"
                                        placeholder={`Enter Your ${
                                          cityLabel || ""
                                        }`}
                                        value={city}
                                        onChange={(e) =>
                                          setCity(e.target.value)
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div className="col-lg-6 col-md-6">
                                    <div className="login-inputDiv">
                                      <label
                                        htmlFor="exampleInputzipcode"
                                        className="form-label"
                                      >
                                        {zipCodeLabel}
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="exampleInputzip"
                                        placeholder={`Enter Your ${
                                          zipCodeLabel || ""
                                        }`}
                                        value={zipCode}
                                        onChange={(e) =>
                                          setZipCode(e.target.value)
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div className="col-lg-6 col-md-6">
                                    <div className="login-inputDiv">
                                      <label
                                        htmlFor="exampleInputcity"
                                        className="form-label"
                                      >
                                        {stateLabel}
                                      </label>
                                      <input
                                        type="state"
                                        className="form-control"
                                        id="exampleInputstate"
                                        placeholder={`Enter Your ${
                                          stateLabel || ""
                                        }`}
                                        value={state}
                                        onChange={(e) =>
                                          setState(e.target.value)
                                        }
                                      />
                                    </div>
                                  </div>
                                  {contractorUniqueCode ? null : (
                                    <div className="col-lg-6 col-md-6">
                                      <div className="login-inputDiv">
                                        <label
                                          htmlFor="exampleInputcountry"
                                          className="form-label"
                                        >
                                          Country
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          id="exampleInputcountry"
                                          placeholder="Enter Your Country"
                                          value={country}
                                          onChange={(e) =>
                                            setCountry(e.target.value)
                                          }
                                        />
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="dashprofile-card">
                    <div className="row">
                      <div className="col-xxl-10">
                        <div className="row justify-content-center">
                          <div className="col-xxl-10 col-xl-10">
                            <h3 className="dashsmall-bluetitle">
                              {privacyInformationHeading}
                            </h3>
                            <div className="login-form pt-0 pb-0">
                              <div className="row">
                                <div className="col-lg-6 col-md-6">
                                  <div className="login-inputDiv">
                                    <label
                                      htmlFor="exampleInputaddress"
                                      className="form-label"
                                    >
                                      {newPasswordLabel}
                                    </label>
                                    <div style={{ position: "relative" }}>
                                      <input
                                        type={
                                          showNewPassword ? "text" : "password"
                                        }
                                        className="form-control"
                                        id="exampleInputPassword1"
                                        placeholder={`Enter ${
                                          newPasswordLabel || ""
                                        }`}
                                        value={newPassword}
                                        onChange={handleNewPasswordChange}
                                      />

                                      <i
                                        className={`fa ${
                                          showNewPassword
                                            ? "fa-eye"
                                            : "fa-eye-slash"
                                        }`}
                                        onClick={toggleNewPasswordVisibility}
                                        style={{
                                          position: "absolute",
                                          top: "50%",
                                          right: "15px",
                                          transform: "translateY(-50%)",
                                          cursor: "pointer",
                                          color: "#bbb",
                                        }}
                                        aria-hidden="true"
                                      ></i>
                                    </div>
                                    {newPasswordError && (
                                      <div className="validation-error">
                                        {newPasswordError}
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                  <div className="login-inputDiv">
                                    <label
                                      htmlFor="exampleInputaddress"
                                      className="form-label"
                                    >
                                      {confirmPassworLabel}
                                    </label>
                                    <div style={{ position: "relative" }}>
                                      <input
                                        type={
                                          showConfirmPassword
                                            ? "text"
                                            : "password"
                                        }
                                        className="form-control"
                                        id="exampleInputPassword1"
                                        placeholder={`Enter ${
                                          confirmPassworLabel || ""
                                        }`}
                                        value={confirmPassword}
                                        // onChange={(e) =>
                                        //   setConfirmPassword(e.target.value)
                                        // }
                                        onChange={handleConfirmPasswordChange}
                                      />

                                      <i
                                        className={`fa ${
                                          showConfirmPassword
                                            ? "fa-eye"
                                            : "fa-eye-slash"
                                        }`}
                                        onClick={
                                          toggleConfirmPasswordVisibility
                                        }
                                        style={{
                                          position: "absolute",
                                          top: "50%",
                                          right: "15px",
                                          transform: "translateY(-50%)",
                                          cursor: "pointer",
                                          color: "#bbb",
                                        }}
                                        aria-hidden="true"
                                      ></i>
                                    </div>
                                    {confirmPasswordError && (
                                      <div className="validation-error">
                                        {confirmPasswordError}
                                      </div>
                                    )}
                                  </div>
                                </div>
                                {/* {errorMessage && (
                                  <div className="validation-error">
                                    {errorMessage}
                                  </div>
                                )} */}

                                <div className="col-lg-12">
                                  <div className="d-flex gap-3">
                                    {loading ? (
                                      <>
                                        {" "}
                                        <button
                                          className="success-orangebtn"
                                          type="button"
                                          disabled
                                        >
                                          <span
                                            className="spinner-border spinner-border-sm me-1 custom-spinner"
                                            role="status"
                                            aria-hidden="true"
                                          ></span>
                                          Loading...
                                        </button>
                                      </>
                                    ) : (
                                      <button
                                        type="submit"
                                        className="success-orangebtn"
                                        onClick={handleUpdateProfile}
                                      >
                                        Update
                                      </button>
                                    )}
                                    <button
                                      className="success-orangebtn success-grayborderbtn"
                                      onClick={handleCancelClick}
                                    >
                                      Cancel
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateProfile;
